<template>
    <div class="af-app af-searchbar">
        <Searchbar @hit="handleSearch" />
    </div>
</template>

<script>
    import Searchbar from '@/apps/searchbar/001/components/Searchbar';

    export default {
        name: 'App',

        components: {
            Searchbar,
        },

        methods: {
            handleSearch(obj) {
                let output = '/jobs/';
                if (obj.keyword) {
                    output += `${obj.keyword}-jobs`;
                }

                output += obj?.location?.slug ? `/in-${obj.location.slug}` : '';

                if (obj?.classifications) {
                    let cls_slug = '';
                    obj.classifications.forEach((c) => {
                        cls_slug += `_cla_${c.slug}`;
                        c.subclassifications.forEach((s) => {
                            cls_slug += `_scla_${s.slug}`;
                        });
                    });

                    if (cls_slug) {
                        cls_slug = cls_slug.substring(1);
                    }

                    output += `/${cls_slug}`;
                }

                window.location.href = output;
            },
        },
    };
</script>
